import { useTranslation } from 'react-i18next'

import { useAppPath } from '@/hooks/useAppPath'
import { LicenseBookingMode, licenseSlice } from '@/store/licenseSlice'
import { ONE_MINUTE } from '@/utils/constants'
import { getSpotsPageByBookingMode } from '@/utils/getSpotsPageByBookingMode'
import { TICKETS_PATH } from '../../app/router/paths'
import { KioskSpot } from '../../assets/icons/KioskSpot'
import { KioskTicket } from '../../assets/icons/KioskTicket'
import { KioskTimeoutDialog } from '../../components/Dialog/KioskTimeoutDialog'
import { KioskCard } from '../../components/KioskCard'
import { useAppDispatch, useAppSelector } from '../../hooks/store'
import { BookingAvailability } from '../../store/bookingAvailabilitySlice'
import { cartSlice } from '../../store/cartSlice'

interface Props {
  areSpotsAvailable: boolean
  areTicketsAvailable: boolean
}

export const ChooseProductKiosk = (props: Props) => {
  const { t } = useTranslation()
  const license = useAppSelector(licenseSlice.selectors.license)
  const dispatch = useAppDispatch()

  const ticketsPath = useAppPath(TICKETS_PATH)
  const spotsPage = getSpotsPageByBookingMode(
    license?.bookingMode || LicenseBookingMode.MAP
  )
  const spotsPath = useAppPath(spotsPage)

  if (!license) return null

  const handleClick = (bookingType: BookingAvailability) => () => {
    dispatch(cartSlice.actions.setBookingType(bookingType))
  }

  return (
    <>
      <main className="flex flex-1 flex-col items-center justify-center">
        <h1 className="sr-only">{t('chooseProduct.kiosk.pageTitle')}</h1>

        <h2 className="mb-6 text-center text-[1.25rem] font-bold leading-[1.5rem]">
          {t('chooseProduct.kiosk.title')}
        </h2>

        <div className="mb-8 flex gap-4 px-4">
          <KioskCard
            description={t('chooseProduct.kiosk.spot.description')}
            icon={<KioskSpot />}
            isSoldOut={!props.areSpotsAvailable}
            onClick={handleClick(BookingAvailability.SPOTS)}
            title={t('chooseProduct.kiosk.spot.title')}
            to={spotsPath}
          />

          <KioskCard
            description={t('chooseProduct.kiosk.ticket.description')}
            icon={<KioskTicket className="text-yellow-300" />}
            isSoldOut={!props.areTicketsAvailable}
            onClick={handleClick(BookingAvailability.TICKETS)}
            title={t('chooseProduct.kiosk.ticket.title')}
            to={ticketsPath}
          />
        </div>
      </main>

      <div />

      <KioskTimeoutDialog timeout={ONE_MINUTE} />
    </>
  )
}
